<template>
  <b-card>
    <b-card-title>Nivel académico</b-card-title>

    <b-skeleton-wrapper :loading="loader">
      <template #loading>
        <b-skeleton
          v-for="each in 6"
          :key="each"
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>

      <b-button
        v-for="{ id, nivel } in data"
        :key="id"
        :variant="selected === id ? 'primary' : 'light'"
        class="mb-75"
        block
        @click="() => handleClick(id)"
      >
        {{ nivel }}
      </b-button>
    </b-skeleton-wrapper>

    <b-card-footer class="pb-0 px-0 text-center">
      <small>Da clic en algún filtro para seleccionar, o vuelva a dar clic para deseleccionar</small>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardFooter,
  BButton,
  BCardTitle,
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import getNivelAcademicoCatalogo from './useFiltroNivelAcademico'

export default {
  components: {
    BCard,
    BCardFooter,
    BButton,
    BCardTitle,
    BSkeletonWrapper,
    BSkeleton,
  },
  setup(_, { emit }) {
    const toast = useToast()
    const seachString = ref('')
    const loader = ref(false)
    const data = ref([])
    const selected = ref(null)

    const fetchData = async () => {
      try {
        loader.value = true
        const result = await getNivelAcademicoCatalogo()

        data.value = result
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en solicitud [nivel académico]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      } finally {
        loader.value = false
      }
    }

    const handleClick = id => {
      if (selected.value === id) {
        emit('item-selected', null)
        selected.value = null
        return
      }

      emit('item-selected', id)

      selected.value = id
    }

    onMounted(() => fetchData())

    return {
      loader,
      seachString,
      selected,
      data,

      handleClick,
    }
  },
}
</script>
